import React from 'react';
import { CardButton } from '../../../../../components/Card';
import AddAccountModal from '../modals/AddAccountModal/AddAccountModal';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';
import { ReactComponent as AddDottedIcon } from '../../../../../resource/AddDottedIcon.svg';
import { useSelector } from 'react-redux';

const ModalFactory = ({ ...props }) => {
      return <AddAccountModal {...props} />;
};

const ButtonFactory = ({ ...props }) => {
      return (
        <CardButton
          icon={<AddDottedIcon />}
          text={props.text}
          block
          onClick={props.onClick}
          className={props.className}
        />
      );
};

const ActionWithModalAccounts = ({
  actionText,
  actionClassName,
  modalProps,
}) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const { CanEditIndividualMeters: canAdd } =
  useSelector((state) => state.authentication.userInfo) || {};

  return (
    <>
      <ButtonFactory
        text={actionText}
        onClick={canAdd ? () => showModal() : undefined}
        className={actionClassName}
      />
      <ModalFactory
        {...modalProps}
        visible={visible}
        onCancel={hideModal}
      />
    </>
  );
};

export default ActionWithModalAccounts;
